<etn-autocomplete
  [placeholder]="placeholder"
  [value]="value?.id"
  [values]="values$ | async"
  [hideProgressBar]="true"
  (search)="onSearch($event)"
  (valueSelect)="onValueSelect($event)"
  (clear)="onClear()"
></etn-autocomplete>
